import Signals from '../signals/Signals';
export function createErrorResponse(component, error) {
    try {
        var errors = error.error.response.body.errors;
        component.setState({ errors: errors, submitting: false });
    }
    catch (err) {
        component.setState({ submitting: false });
        Signals.ShowNotification.dispatch('Er is iets misgegaan: ' + error.error.message, 'danger');
    }
}
/**
 *
 * @param errors
 * @param fieldName
 * @param intl
 * @return {undefined}
 */
export function extractErrorMessage(errors, fieldName, intl) {
    if (!errors)
        return undefined;
    var message = undefined;
    if (errors[fieldName]) {
        errors[fieldName].forEach(function (error) {
            var errorMessage = intl ? intl.formatMessage({ id: error }) : error;
            if (!message) {
                message = !message ? errorMessage : ', ' + errorMessage;
            }
        });
        //remove
        errors[fieldName] = null;
    }
    return message;
}
/**
 *
 * @param state
 * @param intl
 * @param suppress
 */
export function notifyUncaughtErrors(state, intl, suppress) {
    var errors = state.errors;
    var keys = errors ? Object.keys(errors) : [];
    var suppressKeys = suppress ? suppress : [];
    var message = '';
    keys.map(function (key) {
        if (!suppressKeys.includes(key)) {
            message += message.length > 0 ? ', ' : '';
            var msg = extractErrorMessage(errors, key, intl);
            message += msg ? key + ': ' + msg : '';
        }
    });
    if (message.length > 0 && keys.length > 0) {
        Signals.ShowNotification.dispatch(message, 'danger');
    }
    state.errors = [];
}
/**
 *
 * @param errors
 * @param fieldName
 * @return {boolean}
 */
export function hasError(errors, fieldName) {
    if (!errors)
        return false;
    if (!errors.forEach)
        return false;
    var hasError = false;
    errors.forEach(function (error) {
        if (error && error.length > 0 && error[0] === fieldName) {
            hasError = true;
        }
    });
    return hasError;
}
